import * as React from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getAllCoursesAsync } from '../Courses/CourseStore/courseStoreSlice';
import {
  addItemToCartAsync,
  getCartByUserAsync,
} from './CartStore/cartStoreSlice';
import { getAllUsersAsync } from '../User/UserStore/userStoreSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

// const categories = [
//   {
//     categoryName: 'Certificate Course',
//   },
//   {
//     categoryName: 'Graduate Diploma',
//   },
//   {
//     categoryName: 'Post Graduate Diploma',
//   },
// ];

const AddCourseForm = () => {
  // const [courseName, setCourseName] = React.useState(null);
  const [selectedCourse, setSelectedCourse] = React.useState(null);
  const [selectedUser, setSelectedUser] = React.useState(null);

  const dispatch = useDispatch();
  const { courses, users, userCart } = useSelector((state) => {
    const { programReducer, coursesReducer, userReducer, cartReducer } = state;

    return {
      programs: programReducer.programs,
      courses: coursesReducer.courses,
      users: userReducer.users,
      userCart: cartReducer.userCart,
    };
  });

  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      dispatch(getAllCoursesAsync())
        .unwrap()
        .then(() => {
          toast.success('All Courses were fetched successfully.');
        });

      dispatch(getAllUsersAsync())
        .unwrap()
        .then(() => {
          toast.success('All Users were fetched successfully.');
        });
    } catch (error) {
      toast.error('Some data could not be fetched. Please try again!');
    }
  };

  const fetchCart = async () => {
    try {
      dispatch(getCartByUserAsync(selectedUser._id))
        .unwrap()
        .then(() => {
          toast.success(
            `User ${selectedUser.name}'s cart fetched successfully.`
          );
        });
    } catch (error) {
      toast.error('Cart could not be fetched, please try again!');
    }
  };

  const addCourseToCart = async () => {
    try {
      let payload = {
        userId: selectedUser._id,
        item: selectedCourse._id,
      };
      dispatch(addItemToCartAsync(payload))
        .unwrap()
        .then(() => {
          toast.success('Cart was added successfully for the user.');
          fetchCart();
        });
    } catch (error) {
      toast.error('Courses could not be added to cart.');
    }
  };
  console.log(userCart);
  return (
    <Box sx={style}>
      <Box>
        <Typography>Add a cart</Typography>
        <Box alignItems="center">
          <Box mt={2} />
          <Box>
            <Autocomplete
              disablePortal
              fullWidth
              onChange={(e, value) => setSelectedUser(value)}
              id="combo-box-demo"
              options={users}
              getOptionLabel={(option) => String(option.name)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="User"
                  variant="outlined"
                  size="small"
                />
              )}
            />
          </Box>

          <Box mt={2} />
          <Box>
            <Autocomplete
              disablePortal
              fullWidth
              onChange={(e, value) => setSelectedCourse(value)}
              id="combo-box-demo"
              options={courses}
              getOptionLabel={(option) => String(option.courseName)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Course"
                  variant="outlined"
                  size="small"
                />
              )}
            />
          </Box>
        </Box>

        <Box my={2}>
          <Button variant="contained" color="primary" onClick={addCourseToCart}>
            Add Course to Cart
          </Button>
        </Box>

        <Box my={2}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Course Name</TableCell>s
                </TableRow>
              </TableHead>
              <TableBody>
                {userCart &&
                  userCart.items.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                      }}>
                      <TableCell component="th" scope="row">
                        {row}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Box>
  );
};

export default AddCourseForm;
